import {Observable} from "rxjs";
import {ICommand} from "../../modules/records/commands/i-command";
import {IApiService} from "../../modules/records/models/api/i-api-service";
import {RecordsManager} from "../../modules/records/records-manager";
import { MyUtils, SettingsPayload } from "src/app/services/my-utils.service";

export class CreateCommentOnlineRepCommand<
  T extends object & { responseCreateBtn: string },
  S extends IApiService<T> & {
    showDialogCommentsOnlineRep: (el: T) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" | undefined = "raised";
  label = "RESPONSE";
  /*distributionList = {
    title: this.utils.traslatei18n("Distribution list"),
    path: "admin-module/distribution-list",
    icon: "fact_check"
  }*/
  //label?: string;
  //this.label = this.utils?.traslatei18n("RESPONSE");

  constructor(public service: S, private utils?: MyUtils) {}
  execute(el: T) {
    this.service.showDialogCommentsOnlineRep(el).subscribe((res) => {
      if (res) {
        this.receiver.onSuccess();
      }
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    const isDisabled = el.responseCreateBtn !== '1';
    return isDisabled || this.receiver.isLoading;
  }

  isHidden(el: T) {
    return el.responseCreateBtn !== '1';
  }

}